import type { GridColDef } from '@mui/x-data-grid';
import { raiseUnreachable } from '@vy/utils';
import { formatDate } from '../../../../../../utils/date';
import { MetersTableActions } from '../MetersTableActions';
import type { UnifiedProductRow } from './products-columns-type';
import { CatalogProductsTableActions } from '../CatalogProductsTableActions';
import { CreditTypesTableActions } from '../CreditTypesTableActions';
import { UNIFIED_PRODUCTS_COLUMNS_KEYS } from './products-columns-constants';
import { isCatalogProductRow, isCreditTypeRow, isMeterProductRow } from './products-columns-utils';

export function getProductsPageTableColumns(): GridColDef<UnifiedProductRow>[] {
  return [
    {
      field: UNIFIED_PRODUCTS_COLUMNS_KEYS.NAME,
      headerName: 'Product Name',
      flex: 1,
      sortable: false,
      headerClassName: 'pl-6',
      cellClassName: 'pl-6',
    },
    {
      field: UNIFIED_PRODUCTS_COLUMNS_KEYS.TYPE,
      width: 200,
      headerName: 'Type',
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      headerClassName: 'pr-6',
      cellClassName: 'pr-6',
      valueGetter: (_value, row) => row.type,
    },
    {
      field: UNIFIED_PRODUCTS_COLUMNS_KEYS.CREATED_AT,
      headerName: 'Created On',
      align: 'left',
      sortable: false,
      renderCell: ({ row }) => formatDate(row.createdAt),
    },
    {
      field: UNIFIED_PRODUCTS_COLUMNS_KEYS.ACTIONS,
      headerName: '',
      sortable: false,
      width: 30,
      filterable: false,
      headerClassName: 'bg-white',
      cellClassName: 'bg-white',
      renderCell: ({ row }) => {
        if (isMeterProductRow(row)) {
          return (
            <MetersTableActions row={row} meterId={row.id} disableDelete={false} meterName={row.name} />
          );
        }

        if (isCatalogProductRow(row)) {
          return (
            <CatalogProductsTableActions
              row={row}
              catalogProductId={row.id}
              disableDelete={false}
              catalogProductName={row.name}
            />
          );
        }

        if (isCreditTypeRow(row)) {
          return (
            <CreditTypesTableActions
              row={row}
              creditTypeId={row.id}
              disableDelete={!row.isDeletable}
              creditTypeName={row.name}
            />
          );
        }

        return raiseUnreachable(row);
      },
    },
  ];
}
